import React from 'react';
import Consultancy from '../../components/IT/It.jsx';

const IT = () => {
  return (
    <>
      {/* Footer Section  */}
      <section>
        <Consultancy />
      </section>
    </>
  );
};

export default IT;
